import apiSlice from "services/redux/reducers/apiSlice";
import { BACK_END_API_END_POINTS as AEP } from "app/settings/settings";

const adminProductsApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Products
		adminListTrashedProducts: builder.mutation({
			query: (inputParams = {}) => ({
				url: AEP.products.adminListTrashedProducts.url,
				method: AEP.products.adminListTrashedProducts.method,
				body: { ...inputParams },
			}),
		}),
		adminCreateProduct: builder.mutation({
			query: (inputParams) => {
				if (inputParams instanceof FormData) {
					return {
						url: AEP.products.adminCreateProduct.url,
						method: AEP.products.adminCreateProduct.method,
						body: inputParams,
						formData: true,
					};
				}
				return {
					url: AEP.products.adminCreateProduct.url,
					method: AEP.products.adminCreateProduct.method,
					body: { ...inputParams },
				};
			},
		}),
		adminUpdateProduct: builder.mutation({
			query: (inputParams = {}) => ({
				url: AEP.products.adminUpdateProduct.url,
				method: AEP.products.adminUpdateProduct.method,
				body: { ...inputParams },
			}),
		}),
		adminUpdateProductImage: builder.mutation({
			query: (inputParams) => ({
				url: AEP.products.adminUpdateProductImage.url,
				method: AEP.products.adminUpdateProductImage.method,
				body: inputParams,
				formData: true,
			}),
		}),
		adminTrashProduct: builder.mutation({
			query: (inputParams = {}) => ({
				url: AEP.products.adminTrashProduct.url,
				method: AEP.products.adminTrashProduct.method,
				body: { ...inputParams },
			}),
		}),
		adminRestoreProduct: builder.mutation({
			query: (inputParams = {}) => ({
				url: AEP.products.adminRestoreProduct.url,
				method: AEP.products.adminRestoreProduct.method,
				body: { ...inputParams },
			}),
		}),
		// Categories
		adminListTrashedCategories: builder.mutation({
			query: (inputParams = {}) => ({
				url: AEP.products.adminListTrashedCategories.url,
				method: AEP.products.adminListTrashedCategories.method,
				body: { ...inputParams },
			}),
		}),
		adminCreateCategory: builder.mutation({
			query: (inputParams) => {
				if (inputParams instanceof FormData) {
					return {
						url: AEP.products.adminCreateCategory.url,
						method: AEP.products.adminCreateCategory.method,
						body: inputParams,
						formData: true,
					};
				}
				return {
					url: AEP.products.adminCreateCategory.url,
					method: AEP.products.adminCreateCategory.method,
					body: { ...inputParams },
				};
			},
		}),
	}),
});

export const {
	useAdminListTrashedProductsMutation,
	useAdminCreateProductMutation,
	useAdminUpdateProductMutation,
	useAdminUpdateProductImageMutation,
	useAdminTrashProductMutation,
	useAdminRestoreProductMutation,
	useAdminListTrashedCategoriesMutation,
	useAdminCreateCategoryMutation,
} = adminProductsApi;

export default adminProductsApi;
